/**
 * Puente de CATÁLOGO de media (F2-B → F2-D `gen:features`).
 *
 * Emite `FeatureManifest`s (misma forma que `countryPackManifests()`) para las
 * features de media que viven en registries TS: el bloque `video`. Los meeting
 * providers exponen su propio `mediaProviderManifests()` en `../live`.
 */

import type { FeatureManifest } from "../academy/country/packs";
import { videoBlock } from "../learning-blocks/blocks/video";

/** Clave de catálogo del bloque de vídeo. */
export const VIDEO_BLOCK_KEY = "media.block.video";

/** Manifest catalog-ready del bloque `video` (key `media.block.video`). */
export function videoBlockManifest(): FeatureManifest {
  return {
    key: VIDEO_BLOCK_KEY,
    name: "Bloque de vídeo",
    description: `Reproduce un vídeo VOD (${videoBlock.type}) y lo completa por visionado (minWatchPct).`,
    scope: "course",
    status: "stable",
    gateable: true,
    since: "2026-06",
    docsSlug: "profesor",
    implications: {
      navHidden: ["«Vídeo» en el menú de bloques/módulos"],
      flowsBlocked: ["Subir vídeos nuevos"],
      dataPolicy: "preserved",
    },
  };
}
